export const RENEWAL_PERIOD = {
	MONTHLY: {
		id: 0,
		label: 'Månadsvis',
	},
	QUARTERLY: {
		id: 1,
		label: 'Kvartalsvis',
	},
	YEARLY: {
		id: 2,
		label: 'Årligen',
	},
	LIST: [
		{
			id: 0,
			label: 'Månadsvis',
			key: 'MONTHLY',
		},
		{
			id: 1,
			label: 'Kvartalsvis',
			key: 'QUARTERLY',
		},
		{
			id: 2,
			label: 'Årligen',
			key: 'YEARLY',
		},
	],
};

export const ADDON_MAPPER = {
	LIST: {
		AI_FUNCTIONS: 'Ai Funktioner',
		RM_HANDBOOK: 'HR Handbok',
		LEGAL_COMMENTS: 'Lagkommentarer',
		E_LITERATURE: 'E-Litteratur',
		COMPLIANCE: 'Lagbevakning (Extern)',
		LEGAL_CASE_PLUS: 'Rättsfall Plus',
		SOCRATES: 'Socrates',
	},
	KEYS: {
		AI_FUNCTIONS: 'AI_FUNCTIONS',
		RM_HANDBOOK: 'RM_HANDBOOK',
		LEGAL_COMMENTS: 'LEGAL_COMMENTS',
		E_LITERATURE: 'E_LITERATURE',
		COMPLIANCE: 'COMPLIANCE',
		LEGAL_CASE_PLUS: 'LEGAL_CASE_PLUS',
		SOCRATES: 'SOCRATES',
	},
};



// WEBPACK FOOTER //
// ./src/config/common.js